<template>
  <div>
    <tree-view :tree="treeData" v-on:operate="operate"></tree-view>
  </div>
</template>

<script>
  import TreeView from '@/components/utils/tree-view'
  import { DeviceTree } from '@/components/home/controllers/device.js'

  const data = {
    treeData: []
  }

  export default {
    created () {
      this._imported = () => this.updateTreeData()

      this.$emitter.on('imported', this._imported)
      this.$emitter.on('reload-device-tree', this.updateTreeData)
      this.deviceTree = new DeviceTree(this)
      this.updateTreeData()

      this.deviceTree.afterSubmitHook = () => {
        this.updateTreeData()
      }
    },
    destroyed () {
      this.$emitter.removeListener('imported', this._imported)
      this.$emitter.removeListener('reload-device-tree', this.updateTreeData)
    },
    data () {
      return data
    },
    components: {
      TreeView
    },
    methods: {
      operate (operation, data) {
        this.deviceTree.processOperation(operation, data)
          .then(() => {
            this.updateTreeData()
          })
      },
      updateTreeData () {
        this.deviceTree.genTreeData().then(data => {
          this.treeData = data
        })
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/home/trees/device-tree.vue